import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import { Series } from 'rebook/apps/catalog/models';

import styles from './style.scss';


const SeriesItem = ({ series, bookList }) => {
  const theSeries = new Series(series);
  return (
    <li className={styles.series}>
      <Link to={theSeries.getLink()} className={styles.link}>
        <h3>{theSeries.name}</h3>
      </Link>
      <div className={styles.slider}>
        <VerticalBookCardList bookList={bookList} />
      </div>
    </li>
  );
};

const BookDetailSeriesList = ({ book, seriesList }) => {
  // filter out series with only 1 book
  const actualSeriesList = seriesList.filter(
    (item) => item.series.active_book_count > 1
  );
  const seriesTitle = [null, 'Входит в серию', 'Входит в серии'][actualSeriesList.length];

  if (actualSeriesList.length === 0) {
    return null;
  }

  return (
    <div className="billetContainerNoOverflow">
      <div className={styles.content}>
        <h2>{seriesTitle}</h2>
      </div>
      <div>
        <ul>
          {actualSeriesList.map(({ series, books }) => (
            <SeriesItem series={series} activeBook={book} bookList={books} key={series.id} />
          ))}
        </ul>
      </div>
    </div>
  );
};

BookDetailSeriesList.propTypes = {
  book: PropTypes.object.isRequired,
  seriesList: PropTypes.arrayOf(
    PropTypes.shape({
      series: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      }),
      books: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
        })
      ),
    })
  ),
};

export default BookDetailSeriesList;
